import React from "react";
import { ProductScreen, Appbar, useMobileMenu } from "../produits/productMobileKit";
import ShipmentDetail from "../../gestion-logistics/pages/ShipmentDetail";

export default function ShipmentDetailMobile() {
  const onMenu = useMobileMenu();
  return <ProductScreen><Appbar title="Fiche dossier" onMenu={onMenu} />
    <div className="shipment-native-mobile"><ShipmentDetail /></div>
  </ProductScreen>;
}
